import { render } from "./InfoGeneral.vue?vue&type=template&id=138c99fc"
import script from "./InfoGeneral.vue?vue&type=script&lang=js"
export * from "./InfoGeneral.vue?vue&type=script&lang=js"

import "./InfoGeneral.vue?vue&type=style&index=0&id=138c99fc&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__